// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradient {
  background-image: linear-gradient(to bottom, #373f50 4%, #008cce 88%, rgba(0, 140, 206, 0.7) 100%);
  color: #fff;
}

.header-first-component-container {
  width: 100%;
  padding: 33px 0px 20px 0px;
  font-family: "Source Sans Pro", sans-serif;
  color: #fff;
}
.header-first-component-container .header {
  font-size: 34px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.51px;
  color: #fff;
  text-align: center;
}
.header-first-component-container .header img.iconmanage_pillar_topics {
  width: 50px;
  height: 50px;
  flex-grow: 0;
  object-fit: contain;
}

.marketing-card-container {
  padding: 55px;
}

.section-header {
  font-size: 24px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.04px;
  margin-bottom: 10px;
}

.sub-header {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: 0.08px;
  margin-bottom: 33px;
}

.image-text-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
.image-text-container .image img {
  flex-grow: 0;
  object-fit: contain;
}
.image-text-container .text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: 0.08px;
  text-align: left;
}
.image-text-container .text-button {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;
  align-items: center;
  min-height: 340px;
}
.image-text-container .text-button .button-group {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}
.image-text-container .text-button .button-group .plan-description {
  font-size: 16px;
  font-weight: 300;
}

.image-text-container-vertical {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
}
.image-text-container-vertical .image-stack-container {
  width: 615px;
  padding-top: 10px;
}
.image-text-container-vertical .image-stack {
  width: 615px;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  position: relative;
}
.image-text-container-vertical .image-top {
  grid-column: 1/span 8;
  grid-row: 1;
  padding-top: 31%;
  padding-left: 48%;
  z-index: 1;
}
.image-text-container-vertical .image-top-left {
  grid-column: 1/span 8;
  grid-row: 1;
  padding-top: 31%;
  padding-left: 22.5%;
  z-index: 1;
}
.image-text-container-vertical .image-top-right {
  grid-column: 1/span 8;
  grid-row: 1;
  padding-top: 31%;
  padding-left: 83.4%;
  z-index: 1;
}
.image-text-container-vertical .image-bottom {
  grid-column: 1/-1;
  grid-row: 1;
}
.image-text-container-vertical .image-bottom-right {
  grid-column: 1/-1;
  grid-row: 1;
  padding-left: 40.5%;
}
.image-text-container-vertical .image img {
  flex-grow: 0;
  object-fit: contain;
}
.image-text-container-vertical .wide-image {
  width: 90%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
.image-text-container-vertical .wide-image img {
  width: 100%;
  margin: 70px 0px 40px;
}
.image-text-container-vertical .text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: 0.08px;
  text-align: left;
}
.image-text-container-vertical .text-header {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: 0.08px;
  text-align: left;
}
.image-text-container-vertical .text-button .button-group {
  align-self: center;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}
.image-text-container-vertical .text-button .button-group .plan-description {
  font-size: 16px;
  font-weight: 300;
}
.image-text-container-vertical .jfs {
  justify-content: flex-start;
  padding-top: 15px;
}
.image-text-container-vertical .jfs .text {
  padding-bottom: 25px;
}

.image-text-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
.image-text-container .image-stack-container {
  width: 615px;
  padding-top: 10px;
}
.image-text-container .image-stack {
  width: 615px;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  position: relative;
}
.image-text-container .image-top {
  grid-column: 1/span 8;
  grid-row: 1;
  padding-top: 31%;
  padding-left: 48%;
  z-index: 1;
}
.image-text-container .image-top-left {
  grid-column: 1/span 8;
  grid-row: 1;
  padding-top: 31%;
  padding-left: 22.5%;
  z-index: 1;
}
.image-text-container .image-top-right {
  grid-column: 1/span 8;
  grid-row: 1;
  padding-top: 31%;
  padding-left: 83.4%;
  z-index: 1;
}
.image-text-container .image-bottom {
  grid-column: 1/-1;
  grid-row: 1;
}
.image-text-container .image-bottom-right {
  grid-column: 1/-1;
  grid-row: 1;
  padding-left: 40.5%;
}
.image-text-container .image img {
  flex-grow: 0;
  object-fit: contain;
}
.image-text-container .text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: 0.08px;
  text-align: left;
}
.image-text-container .text-header {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: 0.08px;
  text-align: left;
}
.image-text-container .text-button {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;
  align-items: center;
  min-height: 340px;
}
.image-text-container .text-button .button-group {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}
.image-text-container .text-button .button-group .plan-description {
  font-size: 16px;
  font-weight: 300;
}
.image-text-container .jfs {
  justify-content: flex-start;
  padding-top: 15px;
}
.image-text-container .jfs .text {
  padding-bottom: 25px;
}

.j-sb {
  justify-content: space-between;
}

.pr-25 {
  padding-right: 25px;
}

.upgrade-message {
  font-family: "Source Sans Pro", sans-serif;
  margin-top: 60px;
  font-size: 24px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.96;
  letter-spacing: 0.12px;
  text-align: center;
  color: #008cce;
}

.rd-subheader {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 24px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.04px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/shared/marketingPages.scss"],"names":[],"mappings":"AACA;EACE,kGAAA;EAMA,WAAA;AALF;;AAOA;EACE,WAAA;EACA,0BAAA;EACA,0CAAA;EAEA,WAAA;AALF;AAME;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAJJ;AAMI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAJN;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AALF;;AAOA;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AAJF;;AAMA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;AAHF;AAIE;EACE,YAAA;EACA,mBAAA;AAFJ;AAIE;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AAFJ;AAIE;EACE,aAAA;EACA,wBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;AAFJ;AAGI;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;AADN;AAEM;EACE,eAAA;EACA,gBAAA;AAAR;;AAKA;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,2BAAA;AAFF;AAGE;EACE,YAAA;EACA,iBAAA;AADJ;AAGE;EACE,YAAA;EACA,aAAA;EACA,sCAAA;EACA,kBAAA;AADJ;AAGE;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AADJ;AAGE;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;AADJ;AAGE;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;AADJ;AAGE;EACE,iBAAA;EACA,WAAA;AADJ;AAGE;EACE,iBAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAIE;EACE,YAAA;EACA,mBAAA;AAFJ;AAIE;EACE,UAAA;EACA,aAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AAFJ;AAII;EACE,WAAA;EACA,qBAAA;AAFN;AAKE;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AAHJ;AAKE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AAHJ;AAMI;EACE,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,mBAAA;AAJN;AAKM;EACE,eAAA;EACA,gBAAA;AAHR;AAOE;EACE,2BAAA;EACA,iBAAA;AALJ;AAMI;EACE,oBAAA;AAJN;;AAQA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;AALF;AAME;EACE,YAAA;EACA,iBAAA;AAJJ;AAME;EACE,YAAA;EACA,aAAA;EACA,sCAAA;EACA,kBAAA;AAJJ;AAME;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AAJJ;AAME;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;AAJJ;AAME;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;AAJJ;AAME;EACE,iBAAA;EACA,WAAA;AAJJ;AAME;EACE,iBAAA;EACA,WAAA;EACA,mBAAA;AAJJ;AAOE;EACE,YAAA;EACA,mBAAA;AALJ;AAOE;EACE,0CAAA;EAEA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AANJ;AAQE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AANJ;AAQE;EACE,aAAA;EACA,wBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;AANJ;AAOI;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;AALN;AAMM;EACE,eAAA;EACA,gBAAA;AAJR;AAQE;EACE,2BAAA;EACA,iBAAA;AANJ;AAOI;EACE,oBAAA;AALN;;AAUA;EACE,8BAAA;AAPF;;AASA;EACE,mBAAA;AANF;;AAQA;EACE,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AALF;;AAQA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AALF","sourcesContent":["$demandjump-green: #44af69;\n.gradient {\n  background-image: linear-gradient(\n    to bottom,\n    #373f50 4%,\n    #008cce 88%,\n    rgba(0, 140, 206, 0.7) 100%\n  );\n  color: #fff;\n}\n.header-first-component-container {\n  width: 100%;\n  padding: 33px 0px 20px 0px;\n  font-family: \"Source Sans Pro\", sans-serif;\n\n  color: #fff;\n  .header {\n    font-size: 34px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: -0.51px;\n    color: #fff;\n    text-align: center;\n\n    img.iconmanage_pillar_topics {\n      width: 50px;\n      height: 50px;\n      flex-grow: 0;\n      object-fit: contain;\n    }\n  }\n}\n.marketing-card-container {\n  padding: 55px;\n}\n\n.section-header {\n  font-size: 24px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 0.04px;\n  margin-bottom: 10px;\n}\n.sub-header {\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.44;\n  letter-spacing: 0.08px;\n  margin-bottom: 33px;\n}\n.image-text-container {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n  .image img {\n    flex-grow: 0;\n    object-fit: contain;\n  }\n  .text {\n    font-family: \"Source Sans Pro\", sans-serif;\n    font-size: 16px;\n    font-weight: 300;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.44;\n    letter-spacing: 0.08px;\n    text-align: left;\n  }\n  .text-button {\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: space-around;\n    align-items: center;\n    min-height: 340px;\n    .button-group {\n      display: flex;\n      flex-flow: column nowrap;\n      align-items: center;\n      .plan-description {\n        font-size: 16px;\n        font-weight: 300;\n      }\n    }\n  }\n}\n.image-text-container-vertical {\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  justify-content: flex-start;\n  .image-stack-container {\n    width: 615px;\n    padding-top: 10px;\n  }\n  .image-stack {\n    width: 615px;\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    position: relative;\n  }\n  .image-top {\n    grid-column: 1 / span 8;\n    grid-row: 1;\n    padding-top: 31%;\n    padding-left: 48%;\n    z-index: 1;\n  }\n  .image-top-left {\n    grid-column: 1 / span 8;\n    grid-row: 1;\n    padding-top: 31%;\n    padding-left: 22.5%;\n    z-index: 1;\n  }\n  .image-top-right {\n    grid-column: 1 / span 8;\n    grid-row: 1;\n    padding-top: 31%;\n    padding-left: 83.4%;\n    z-index: 1;\n  }\n  .image-bottom {\n    grid-column: 1 / -1;\n    grid-row: 1;\n  }\n  .image-bottom-right {\n    grid-column: 1 / -1;\n    grid-row: 1;\n    padding-left: 40.5%;\n  }\n\n  .image img {\n    flex-grow: 0;\n    object-fit: contain;\n  }\n  .wide-image {\n    width: 90%;\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: flex-start;\n    align-items: flex-start;\n\n    img {\n      width: 100%;\n      margin: 70px 0px 40px;\n    }\n  }\n  .text {\n    font-family: \"Source Sans Pro\", sans-serif;\n    font-size: 16px;\n    font-weight: 300;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.44;\n    letter-spacing: 0.08px;\n    text-align: left;\n  }\n  .text-header {\n    font-size: 16px;\n    font-weight: 500;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.44;\n    letter-spacing: 0.08px;\n    text-align: left;\n  }\n  .text-button {\n    .button-group {\n      align-self: center;\n      display: flex;\n      flex-flow: column nowrap;\n      align-items: center;\n      .plan-description {\n        font-size: 16px;\n        font-weight: 300;\n      }\n    }\n  }\n  .jfs {\n    justify-content: flex-start;\n    padding-top: 15px;\n    .text {\n      padding-bottom: 25px;\n    }\n  }\n}\n.image-text-container {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n  .image-stack-container {\n    width: 615px;\n    padding-top: 10px;\n  }\n  .image-stack {\n    width: 615px;\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    position: relative;\n  }\n  .image-top {\n    grid-column: 1 / span 8;\n    grid-row: 1;\n    padding-top: 31%;\n    padding-left: 48%;\n    z-index: 1;\n  }\n  .image-top-left {\n    grid-column: 1 / span 8;\n    grid-row: 1;\n    padding-top: 31%;\n    padding-left: 22.5%;\n    z-index: 1;\n  }\n  .image-top-right {\n    grid-column: 1 / span 8;\n    grid-row: 1;\n    padding-top: 31%;\n    padding-left: 83.4%;\n    z-index: 1;\n  }\n  .image-bottom {\n    grid-column: 1 / -1;\n    grid-row: 1;\n  }\n  .image-bottom-right {\n    grid-column: 1 / -1;\n    grid-row: 1;\n    padding-left: 40.5%;\n  }\n\n  .image img {\n    flex-grow: 0;\n    object-fit: contain;\n  }\n  .text {\n    font-family: \"Source Sans Pro\", sans-serif;\n\n    font-size: 16px;\n    font-weight: 300;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.44;\n    letter-spacing: 0.08px;\n    text-align: left;\n  }\n  .text-header {\n    font-size: 16px;\n    font-weight: 500;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.44;\n    letter-spacing: 0.08px;\n    text-align: left;\n  }\n  .text-button {\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: space-around;\n    align-items: center;\n    min-height: 340px;\n    .button-group {\n      display: flex;\n      flex-flow: column nowrap;\n      align-items: center;\n      .plan-description {\n        font-size: 16px;\n        font-weight: 300;\n      }\n    }\n  }\n  .jfs {\n    justify-content: flex-start;\n    padding-top: 15px;\n    .text {\n      padding-bottom: 25px;\n    }\n  }\n}\n\n.j-sb {\n  justify-content: space-between;\n}\n.pr-25 {\n  padding-right: 25px;\n}\n.upgrade-message {\n  font-family: \"Source Sans Pro\", sans-serif;\n  margin-top: 60px;\n  font-size: 24px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 0.96;\n  letter-spacing: 0.12px;\n  text-align: center;\n  color: #008cce;\n}\n\n.rd-subheader {\n  font-family: \"Source Sans Pro\", sans-serif;\n  font-size: 24px;\n  font-weight: 400;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 0.04px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
